module.exports = __webpack_public_path__ + "img/location-icon.f1a10554.svg";